<template>
    <b-card-group v-if="user != undefined" :class="darkmode ? 'd-flex justify-content-center bg-dark' : 'd-flex justify-content-center'">
        <b-form @submit.prevent="$refs.contact.completed && $refs.address.completed ? putUserHandler() : showAlert()">
            <einstellungen-status-card :class="darkmode ? 'bg-dark text-light border-secondary' : ''" v-model="user" />
            <einstellungen-address-card :class="darkmode ? 'bg-dark text-light border-secondary' : ''" v-model="user" ref="address"/>
            <einstellungen-contact-card :class="darkmode ? 'bg-dark text-light border-secondary' : ''" v-model="user" ref="contact"/>
            <einstellungen-loeschen-card :class="darkmode ? 'bg-dark text-light border-secondary' : ''" />
            <b-button class="mt-3" block 
                style="border-top-right-radius:0; border-top-left-radius:0;height:3em" 
                variant="primary" type="submit"
                :disabled="loading"
            >
                Ändern 
                <b-spinner v-if="loading" small /> 
                <img v-else src="../assets/interface/save.svg"
                    class="mt-n1"
                    style="filter:invert(1);height:1em" 
                />
            </b-button>
        </b-form>
    </b-card-group>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { setAlert } from '../tools'
import { BCardGroup, BSpinner } from "bootstrap-vue"
import EinstellungenLoeschenCard from '../components/EinstellungenLoeschenCard.vue'
import EinstellungenContactCard from '../components/EinstellungenContactCard.vue'
import EinstellungenAddressCard from '../components/EinstellungenAddressCard.vue'
import EinstellungenStatusCard from '../components/EinstellungenStatusCard.vue'
export default {
    name: "Einstellungen",
    components:{
        BCardGroup,
        BSpinner,
        EinstellungenLoeschenCard,
        EinstellungenContactCard,
        EinstellungenAddressCard,
        EinstellungenStatusCard
    },
    computed: mapGetters(['user', 'darkmode']),
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        ...mapActions(['putUser', 'updateUser']),
        async putUserHandler() {
            this.loading = true
            try {
                await this.putUser()
                setAlert(this, 'Einstellungen wurden geändert.', 'Speichern erfolgreich', 'success')
            }
            catch (err) {
                setAlert(this, err.response.data, 'Speichern fehlgeschlagen', 'danger')
            }
            this.loading = false
        },
        showAlert(){
            this.$bvToast.toast('Die getätigten Angaben sind fehlerhaft.', {
                title: 'Angaben nicht korrekt.',
                variant: 'danger',
                toaster: 'b-toaster-top-full',
                autoHideDelay: 5000,
                appendToast: true
            })
        }
    },
    async created() {
        try {
            await this.updateUser()
        }
        catch (err) {
            setAlert(this, err.response.data, 'Laden fehlgeschlagen', 'danger')
        }
    }
}
</script>